import React, { useContext, useEffect, useState } from 'react' 
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { CiMenuFries } from "react-icons/ci";
import logo from './image/Logo.png'
import Ear from './image/money.png'
import { TbCashBanknoteFilled } from "react-icons/tb";
import { FaPlus } from "react-icons/fa6";
import { CiUser } from "react-icons/ci";
import { FaPlaystation } from "react-icons/fa6";
import { FaMoneyBillWave } from "react-icons/fa";
import { FaHistory } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa";
import { MdSupportAgent } from "react-icons/md";
import { IoCloudDownloadOutline } from "react-icons/io5";

import './App.css'
import { NavLink, useNavigate } from 'react-router-dom'; 
import { ProfileContext } from './ProfileContext';
import { Api_Url } from './APIUrl';
import { useToken } from './Store';
const Header = () => {

  const [data, setDataone] = useState();
  const [show, setShow] = useState(false);
  const [wallet, setWallet] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const { walletBalance } = useContext(ProfileContext);

   const Profile = () =>{

    try {
      const myHeaders = new Headers();
myHeaders.append("Authorization", `Bearer  ${localStorage.getItem('token')}`);

const requestOptions = {
  method: "GET",
  headers: myHeaders,
  redirect: "follow"
};

fetch(`${Api_Url}api/profile`, requestOptions)
  .then((response) => response.json())
  .then((result) => {
    if(result.success == true){
      setWallet(result?.data?.user?.wallet_balance)
    }else if (result.message === "Token has expired.") {
      // Token has expired, navigate to the login page
      localStorage.removeItem("token");  // Optionally remove the expired token
      window.location.href = "/";  // Redirect to login page
    }
  })
  .catch((error) => console.error(error));
    } catch (error) {
      
    }
   }

  useEffect(() => {

    Profile(); 
  }, [walletBalance])
  



  const navigate = useNavigate();
  
  const { logout } = useToken(state => state);

 const handleLogout = () => {
  logout(); 
  navigate('/'); 
};

  return (
    <div>

        <div className='container-fluid py-2  bg-white maincontent' style={{ boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)'}}> 
            <div className='row'>

              <div className='col-lg-12 col-md-6 col-sm-12'>
                <div className='row'>

                
                <div className='col-4 nnnn'>
                   <div  style={{display:'flex',  alignItems:'center'}}>
                     
                   <CiMenuFries   className='fs-3 ms-2   '  style={{cursor:'pointer'}} onClick={handleShow}/>  
                  <NavLink to='/home'> <img src={logo} alt='logo' className='ms-4 mgi'  style={{width:'30px', height:'30px',    }}/>
                  </NavLink>
                   {/* <p className='mgi text-center mt-4 ms-3'>Logo</p> */}
                </div>

                </div> 


                <div className='col-8'>

                  <div  style={{display:'flex', justifyContent:'end'}}>
                  
                  <NavLink to="/wallet"  style={{textDecoration:'none'}}>        <button
      type="button"
      className=" py-0 pb-1 mt-1   d-flex align-items-center justify-content-between p-2 border rounded bg-light shadow-sm"
      style={{  }}
    >
      {/* Left Section: Icon and Text */}
      <div  style={{display:'flex', justifyContent:'space-between'}}>
      <TbCashBanknoteFilled className='mt-3'  style={{color:'green', fontSize:'16px'}} />
        <div className='px-2' style={{lineHeight:'15px'}}>
          <p className="mb-0 fw-bold text-secondary" style={{ fontSize: "12px" }}>CASH       </p>
          <p className="mb-0 fw-bold text-dark" style={{ fontSize: "16px" }}>  {wallet}  </p>
        </div>
      </div>
      {/* Right Section: "+" Icon */}
      <span
        className="d-flex align-items-center justify-content-center  "
        style={{ width: "16px", height: "16px", }}
      >
        <FaPlus />

      </span>
    </button> </NavLink>
 


               
   <NavLink to="/redeem"  style={{textDecoration:'none',}}>  <button
      type="button"
      className="  mx-2 py-0 pb-1 mt-1 d-flex align-items-center justify-content-between p-2 border rounded bg-light shadow-sm"
      style={{ }}
    >
      {/* Left Section: Icon and Text */}
      <div className="d-flex align-items-center">
        
        <img src={Ear} alt='earning'  style={{width:'20px'}}/>
        <div className='px-2' style={{lineHeight:'15px'}}>
          <p className="mb-0 fw-bold text-secondary" style={{ fontSize: "12px" }}>Earning</p>
          <p className="mb-0 fw-bold text-dark" style={{ fontSize: "16px" }}>0</p>
        </div>
      </div>
    
    </button></NavLink>
                </div>
                </div>
            </div>

            </div>
            </div> 


            <Offcanvas show={show} onHide={handleClose} className="mbl"   style={{width:'30%'}}>
        <Offcanvas.Header closeButton  className='pb-0 mb-0' >
          <Offcanvas.Title>LuDo Batting
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className='px-0'> 

          <div>

            <ul className='myorder ps-0' style={{listStyle:'none', fontSize:'22px', fontWeight:'600'}}>
               <NavLink to="/home" onClick={handleClose} style={{textDecoration:'none'}}><li> <FaPlaystation className='me-2'  style={{ border:'1px solid #000', borderRadius:'50%', padding:'5px', fontSize:'28px'}}/>Play  </li> </NavLink>
              <NavLink to="/profile" onClick={handleClose} style={{textDecoration:'none'}}><li> <CiUser className='me-2'  style={{ border:'2px solid #000', borderRadius:'50%', padding:'5px', fontSize:'28px'}}/>My Profile</li></NavLink>


               
               <NavLink to="/wallet" onClick={handleClose} style={{textDecoration:'none'}}><li> <FaMoneyBillWave className='me-2'  style={{ border:'2px solid #000', borderRadius:'50%', padding:'5px', fontSize:'28px'}}/>My wallet</li> </NavLink>
               <NavLink to="/transaction-history" onClick={handleClose} style={{textDecoration:'none'}}>  <li> <FaHistory className='me-2'  style={{ border:'2px solid #000', borderRadius:'50%', padding:'5px', fontSize:'28px'}}/>History</li>
               </NavLink>


                  <NavLink to="/refer " onClick={handleClose} style={{textDecoration:'none'}}> <li> <FaUserPlus className='me-2'  style={{ border:'2px solid #000', borderRadius:'50%', padding:'5px', fontSize:'28px'}}/>Refer and Earn</li></NavLink>


                  <NavLink to="/support " onClick={handleClose} style={{textDecoration:'none'}}> <li> <MdSupportAgent className='me-2'  style={{ border:'2px solid #000', borderRadius:'50%', padding:'5px', fontSize:'28px'}}/>Support</li> </NavLink>
                  <a href="https://backend.brothersludo.in/storage/apk/brothersludo.apk" download style={{ textDecoration: 'none', color: 'inherit' }}
    >
      <li style={{ listStyle: 'none', cursor: 'pointer' }}>
        <IoCloudDownloadOutline  
          className='me-2'  
          style={{
            border: '2px solid #000', 
            borderRadius: '50%', 
            padding: '5px', 
            fontSize: '28px'
          }}
        />
        Download Apk
      </li>
    </a>


                  <div className='p-4'>
    <button className='btn btn-danger w-100 my-4 colab bg-white text-danger'  onClick={handleLogout}>LOG OUT</button>
</div>
                 
            </ul>
          </div>
        </Offcanvas.Body>
      </Offcanvas>


        </div>
    </div>
  )
}

export default Header